import {
  Box,
  Card,
  Container,
  Divider,
  Grid,
  Paper,
  CardContent,
  Backdrop,
} from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "src/app-redux/hooks";
import { resetAddForm, submitAddForm, loader } from "src/app-redux/warehouse/wareHouseSlice";
import CommonButton from "src/components/CommonButton/CommonButton";
import TabHeader from "src/components/TabHeader/TabHeader";
import { NodWereHouseRoute } from "../../nod-were-house.routes";
import DeleteIcon from "@material-ui/icons/Delete";
import { AddItemInput } from "./components/AddItemInput/AddItemInput";
import CommonMaterialGrid from "src/components/CommonXGrid/CommonMaterialGrid";
import { IAddInventoryItemNod } from "src/common/typings/nod-warehouse";
import { fetchWrapper } from "src/api-client/fetchWrapper";
import UseWindowDimensions from "src/common/utils/getWindowDimensions";
import NewCommonButton from "src/components/CommonButton/NewCommonButton";
import { Edit } from "@material-ui/icons";
import { ContainerDetail, vehicleDetail, indexDetail } from "src/common/typings/warehouse";
import { columns } from "src/modules/nod-were-house/pages/AddItem/components/columns";
import CommonLoader from "src/components/Loader/CommonLoader";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
    },
    pageHeading: {
      fontSize: theme.typography.pxToRem(20),
      color: "#000",
      lineHeight: "28px",
    },
    breadcrumbs: {
      fontSize: theme.typography.pxToRem(12),
    },
    backdrop: {
      zIndex: theme.zIndex.modal + 1,
      color: "#fff",
    },
    ".hidden": {
      overflow: "hidden",
    },
    accordionsSection: {
      overflow: "auto",
    },
    seeMoreBlock: {
      maxWidth: "150px",
    },
    moreInfoBlock: {
      width: "100%",
      display: "none",
      background: "#f6f6f6",
      position: "absolute",
      top: "40px",
      paddingBottom: "10px",
    },
    ".seeMoreBlock:hover > .moreInfoBlock": {
      background: "red",
    },
    cardMainParent: {
      float: "left",
      width: "100%",
    },
    tabCard: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      boxShadow: "none",
      borderRadius: "0px",
      borderRight: `1px solid ${theme.palette.divider}`,
    },
    tabCardContent: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      boxShadow: "none",
      borderRadius: "0px",
    },
    cardMain: {
      marginBottom: "30px",
      paddingTop: "10px",
      width: "calc(100%)",
    },
    tabCardContents: {
      padding: theme.spacing(2),
      backgroundColor: theme.palette.background.paper,
    },
    centeredLabel: {
      textAlign: "center",
      fontWeight: "bold",
      marginBottom: theme.spacing(2),
      fontSize: "1.25rem",
    },
    label: {
      margin: `${theme.spacing(1)}px 0`,
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      color: theme.palette.text.primary,
    },
  })
);
type Props = {};
export function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}

export default function AddInventoryItem({}: Props): React.ReactElement {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const [detail, setDetail] = useState<ContainerDetail | null>();
  const [indexDetail, setIndexDetail] = useState<indexDetail | null>();
  const [vehicleDetail, setVehicleDetail] = useState<vehicleDetail | null>();
  const [inventoryItems, setInventoryItems] = React.useState<IAddInventoryItemNod[]>([]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [vehicleStatusArr, setvehicleStatusArr] = React.useState<any[]>([]);
  const [displayColumns, setDisplayColumns] = React.useState<any>(columns);
  const [itemToRemove, setItemToRemove] = React.useState<IAddInventoryItemNod | undefined>();
  const [itemToEdit, setItemToEdit] = React.useState<IAddInventoryItemNod>(
    {} as IAddInventoryItemNod
  );
  const [loader1, setLoader] = useState(false);

  const loading = useAppSelector(loader);

  const container_detail = (newContainer: ContainerDetail) => {
    setDetail(newContainer);
  };

  const index_detail = (newIndexDetail: indexDetail) => {
    setIndexDetail(newIndexDetail);
  };

  const vehicle_detail = (newVehicleDetail: vehicleDetail) => {
    setVehicleDetail(newVehicleDetail);
  };

  const inventory_items = (items: IAddInventoryItemNod[]): IAddInventoryItemNod[] => {
    setInventoryItems(items);
    if (items.length > 0) {
      setIsButtonDisabled(false);
    }
    return items;
  };
  const { height } = UseWindowDimensions();
  let wHeight = 0;
  wHeight = height - 132;
  useEffect(() => {
    setInventoryItems(inventory_items);
  }, [inventoryItems]);

  const ResetInventoryItems = () => {
    setInventoryItems([]);
    setDetail(null);
    setIndexDetail(null);
    setVehicleDetail(null);
    setIsButtonDisabled(true);
  };

  const getVehicleStatusListing = async () => {
    let results: any = [];
    try {
      //setLoader(true);
      results = await fetchWrapper.get("vehicle-status-get-all?ShowIsActive=true");
      if (results.isSuccess) {
        setvehicleStatusArr(results.value);
      }
      //setLoader(false);
      return;
    } catch (error: any) {
      //setLoader(false);
    }
  };

  useEffect(() => {
    getVehicleStatusListing();
  }, []);
  const [expandedAccordion, setExpandedAccordion] = useState({
    AddItemInput: false,
    doc: false,
    ivr: false,
  });

  const moduleName = NodWereHouseRoute.title;
  const pageHeading = NodWereHouseRoute.subRoutes
    ? NodWereHouseRoute.subRoutes[0].title
    : "Page Title";

  useEffect(() => {
    dispatch(resetAddForm());
  }, []);

  const updateExpandedStatus = (type: number) => {
    switch (type) {
      case 0:
        setExpandedAccordion((prev) => {
          return {
            ...prev,
            AddItemInput: !prev.AddItemInput,
          };
        });
        return;
      default:
        return;
    }
  };

  const listener = async (e: any) => {
    if (
      (e.key === "s" || e.key === "S") &&
      (navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey)
    ) {
      e.preventDefault();
      if (!loader) {
        await dispatch(submitAddForm());
      }
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, [loader]);

  const [isSaved, setIsSaved] = useState(false);
  const handleCreateInventory = async () => {
    const items = {
      nodInventoryCreateRequest: inventoryItems,
    };
    try {
      setLoader(true);
      const response = await fetchWrapper.post("/create-inventory-nod", items);
      setLoader(false);
      setIsSaved(!isSaved);
      setInventoryItems([]);
      ResetInventoryItems();
      if (response?.isSuccess == true && response?.value.isInventoryCreated == true) {
        return response.value?.isInventoryCreated;
      }
    } catch (error) {
      setLoader(false);
      ResetInventoryItems();
      setInventoryItems([]);
      throw error;
    }
  };

  const handleRemoveGridItem = (itemToRemove: IAddInventoryItemNod) => {
    handleSetRemoveItems(itemToRemove);
  };

  const handleEditGridItem = (itemToEdit: IAddInventoryItemNod) => {
    handleSetEdittems(itemToEdit);
  };

  function handleSetRemoveItems(
    newItem: IAddInventoryItemNod | undefined
  ): IAddInventoryItemNod | undefined {
    setItemToRemove(newItem);
    return newItem;
  }

  function handleSetEdittems(newItem: IAddInventoryItemNod): IAddInventoryItemNod {
    setItemToEdit(newItem);
    return newItem;
  }

  const dppr = 10;
  const gridMaxHeight = 200;

  useEffect(() => {
    const transformedColumns: any = columns.map((column: any) =>
      column.accessorKey === "actionButtons"
        ? {
            ...column,
            Cell: function customCell({ row }: any) {
              return (
                <>
                  <NewCommonButton
                    icon={<DeleteIcon />}
                    isDelete={true}
                    onClick={() => {
                      console.log(row.original);
                      handleRemoveGridItem(row.original);
                    }}
                  >
                    Delete
                  </NewCommonButton>
                  <NewCommonButton
                    icon={<Edit />}
                    isDelete={false}
                    onClick={() => {
                      handleEditGridItem(row.original);
                    }}
                  >
                    Edit
                  </NewCommonButton>
                </>
              );
            },
          }
        : column
    );
    setDisplayColumns(transformedColumns);
  }, []);

  return (
    <>
      <Backdrop className={classes.backdrop} open={loading || loader1}>
        <CommonLoader />
      </Backdrop>
      <TabHeader module={moduleName} heading={pageHeading} link={"/gate-entry"} />
      <Box m={2} />
      <Grid container direction="row">
        <Grid item xs={12} md={12} className={classes.cardMainParent}>
          <Paper elevation={3} className={classes.cardMain}>
            <Box pl={2} pr={2}>
              <Grid container direction="row">
                <Grid item xs={12} md={9}>
                  <Typography className={classes.pageHeading}>{pageHeading}</Typography>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Box textAlign="right" mt={1}>
                    <CommonButton cssClass="customSubmitBtn" onClick={ResetInventoryItems}>
                      Reset
                    </CommonButton>
                    <CommonButton
                      cssClass="customSubmitBtn"
                      isGreen
                      disable={isButtonDisabled}
                      onClick={() => {
                        dispatch(handleCreateInventory);
                      }}
                    >
                      Save
                    </CommonButton>
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Box m={1}>
              <Divider />
            </Box>

            <Grid container>
              <Grid item xs={7} md={8} lg={9} component={Card} className={classes.tabCardContent}>
                <Container className="gateInTabs">
                  <>
                    <AddItemInput
                      expand={expandedAccordion.AddItemInput}
                      updateExpandStatus={updateExpandedStatus}
                      containerdetail={container_detail}
                      indexDetail={index_detail}
                      vehicleDetail={vehicle_detail}
                      inventory_Items={inventory_items}
                      itemToRemove={itemToRemove}
                      itemToEdit={itemToEdit}
                      isSaved={isSaved}
                    />
                  </>
                </Container>
              </Grid>
              <Grid item xs={5} md={4} lg={3} component={Card} className={classes.tabCardContent}>
                <div className="gateIn">
                  <Typography variant="h6" component="div" className={classes.centeredLabel}>
                    Vehicle Details
                  </Typography>
                  <Grid item>
                    <Typography className={classes.label}>
                      Vehicle Type: {vehicleDetail?.vehicleType}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.label}>
                      Vehicle Status:{" "}
                      {vehicleStatusArr.find((st: any) => st.id === vehicleDetail?.vehicleStatusId)
                        ?.name || ""}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.label}>
                      Cargo: {vehicleDetail?.cargoTypeName}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.label}>
                      Consignment: {vehicleDetail?.consignmentTypeName}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.label}>
                      Vehicle Entry Date: {vehicleDetail?.dateTime}
                    </Typography>
                  </Grid>
                  <Typography variant="h6" component="div" className={classes.centeredLabel}>
                    Container Information
                  </Typography>
                  <Grid item>
                    <Typography className={classes.label}>Vessel: {detail?.vessel}</Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.label}>Voyage: {detail?.voyage}</Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.label}>Seal Number: {detail?.sealNo}</Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.label}>Bill Number: {detail?.billNo}</Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.label}>
                      Forwarder: {detail?.forwarder}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.label}>
                      Container Type : {detail?.containerType}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.label}>
                      Container Size: {detail?.containerSize}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.label}>
                      Container Load Type: {detail?.containerLoadType}
                    </Typography>
                  </Grid>
                  <Typography variant="h6" component="div" className={classes.centeredLabel}>
                    Index/Item Information
                  </Typography>
                  <Grid item>
                    <Typography className={classes.label}>
                      Consignee: {indexDetail?.consignee}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.label}>
                      Manif Packages: {indexDetail?.manifPackages}{" "}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.label}>
                      Manif CBM: {indexDetail?.manifCBM}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.label}>
                      Manif Weight: {indexDetail?.manifWeight}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.label}>LOC:{indexDetail?.loc}</Typography>
                  </Grid>
                </div>
              </Grid>
              <CardContent className={classes.cardMain} style={{ height: wHeight }}>
                <CommonMaterialGrid
                  defaultPerPageRecord={dppr}
                  height={gridMaxHeight}
                  loader={false}
                  rows={inventoryItems || []}
                  columns={displayColumns}
                />
              </CardContent>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}
